import { addDays } from 'date-fns';
import { useQuery } from 'react-query';
import { Pagination } from '../../../../../../types/Common';
import { wgApi } from '../../../../../app/src/features/api/wgApi';
import { OverviewFilterValues } from '../types/Filter';
import { ConversationSession } from '../types/OverviewTypes';

interface Params {
  partyId?: string;
  page?: number;
  pagelen?: number;
  filters?: Partial<OverviewFilterValues>;
  origin?: string;
  q?: string;
}

interface Response {
  pagination: Pagination;
  items: ConversationSession[];
}

export const CONVERSATIONS_PAGELEN = 10;

const getConversations = async ({
  page,
  filters,
  q,
  partyId,
  origin,
  pagelen = CONVERSATIONS_PAGELEN,
}: Params) => {
  const { data, isError } = await wgApi.get<Response>('/v1/api/conversations', {
    query: {
      pagelen,
      page: page,
      order_by: 'modified_at',
      created_at_ge: filters?.date?.[0]?.toISOString(),
      created_at_le:
        filters?.date?.[1] && addDays(filters?.date[1], 1)?.toISOString(),
      flow_id: filters?.conversationType,
      status: filters?.status,
      assigned_to: filters?.assignedTo,
      origin: filters?.origin,
      origins: origin,
      party_id: partyId,
      q,
    },
  });
  if (isError) throw new Error();
  return data;
};

export const getConversationsQKey = (params: Params) => [
  'conversations',
  params,
];

export const useConversations = (params: Params = {}) => {
  return useQuery(
    getConversationsQKey(params),
    () => getConversations(params),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
    },
  );
};
